// UserFeedGridList.js
'use strict';
'use client';
import { connect } from 'react-redux';
import { goBack } from 'redux-first-history';

import UserFeedGridList from '../page/UserFeedGridList.jsx';

import withRouter from '../component/WithRouter.jsx';

import fetchFeeds from '../action/fetchFeeds.js';
import getListData from '../selector/getListData.js';
import getNetworkingData from '../selector/getNetworkingData.js';
import getMeData from '../selector/getMeData.js';
import { getFeedCategory, sanitizeFeedQuery } from '../resource/feedUtils.js';
import getTranslationKey from '../resource/getTranslationKey.js';

const mapStateToProps = (
  state,
  {
    location,
    match: {
      params: { category: paramCategory },
    },
  }
) => {
  const category = getFeedCategory({
    category: paramCategory,
    search: location.search,
  });
  const sanitizedCategory = sanitizeFeedQuery({ feedName: category });
  const selectPath = ['home', 'users', sanitizedCategory];

  const userIds = getListData(state, selectPath, 'itemIds');
  const nextPage = getListData(state, selectPath, 'nextPage');
  const isNextPageFetching = !!getNetworkingData(
    state,
    [...selectPath, nextPage],
    'isFetching'
  );
  const isAuthed = !!getMeData(state, 'id');

  return {
    category,
    titleI18nId: getTranslationKey({ key: category }),
    nextPage,
    isNextPageFetching,
    userIds,
    isAuthed,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    goBack: () => dispatch(goBack()),
    fetchFeeds: payload => dispatch(fetchFeeds(payload)),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(UserFeedGridList)
);
